export const importImages = (imagePaths: string[]) => {
  return imagePaths.map((path) => import(`${path}`));
};